module.exports = __webpack_public_path__ + "static/og-image-kontakt-de471ed3f639ef29e8b52d13b0cf8ad6.png";